// extracted by mini-css-extract-plugin
export default {"skills_container":"SectionSkills_skills_container__H5fFT","skill":"SectionSkills_skill__r3hES","download":"SectionSkills_download__coh66"};